<template>
    <div>
        <!-- {{allscore}} -->
        <!-- {{progress}} -->
        <!-- <p class="title-text my-0" >Pie Chart (Employee & marks)</p> -->
        <!-- {{trainingScore}} -->
        <!-- {{trainingStatus}} -->
        <div
            v-if="allscore.length > 0 || progress.length > 0"
            class="d-flex flex-row align-items-center justify-content-between p-2"
        >
            <div v-if="allscore.name.length > 0">
                <ApexChart
                    type="pie"
                    width="380"
                    :options="{ ...chartOptions, labels: allscore.name }"
                    :series="allscore.score"
                />
            </div>
            <div v-else>
                <div class="info d-flex gap-3 p-3 mt-2 mb-0 align-items-center">
                    <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div>
                    <p class="my-0 fade-text">Need Training Scores, to generate chart</p>
                </div>
            </div>

            <div v-if="progress.length > 0">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="small">Employee Name</th>
                            <th class="small">In Review</th>
                            <th class="small">Re Assigned</th>
                            <th class="small">Completed</th>

                            <th class="small">Not Yet Started</th>

                            <!-- <th class="small">Total Tasks</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in progress" :key="index" class="text-center">
                            <td>{{ data.userName }}</td>
                            <td>{{ data.inReview }}</td>
                            <td>{{ data.reverted }}</td>
                            <td>{{ data.completed }}</td>
                            <td>{{ data.notStarted }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <div class="info d-flex gap-3 p-3 mt-2 mb-0 align-items-center">
                    <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div>
                    <p class="my-0 fade-text">No Data Found</p>
                </div>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center">
             <div class="info d-inline-flex gap-3 p-3 mt-2 mb-0 align-items-center ">
                    <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div>
                    <p class="my-0 fade-text">No Data to generate chart and table</p>
                </div>
            </div>
           <div v-if="trainingScore">
                <ApexChart type="bar" height="350" :options="{...chartOptions1,xaxis:trainingScore.name}" :series="trainingScore.data" />
            </div> 
            <div class="my-2 mt-4 card">
                <table class="table table-striped my-0">
                    <thead>
                        <tr class="text-center">
                            <th class="small">Employee Name</th>
                            <th class="small" v-for="(label,index) in trainingScore.name.categories" :key="index">{{label}}</th>
                            <th class="small">Total</th>

                            <!-- <th class="small">Total Tasks</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in trainingScore.data" :key="index" class="text-center">
                            <td>{{data.name}}</td>
                            <td v-for="(score,ind) in data.data" :key="ind">{{score}}</td>
                            <td>{{trainingScore.total[index]}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 card">
                <table class="table ">
                    <thead>
                        <tr>
                            <th class="small">Employee Name</th>
                            <th class="small" v-for="(data,index) in trainingStatus.taskname" :key="index">{{data}}</th>

                            <!-- <th class="small">Total Tasks</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(value, index) in trainingStatus.structuredData" :key="index" class="text-center">
                            <td>{{ value.name }}</td>
                            <td v-for="(val,ind) in value.data" :key="ind">
                                <Badge :class="[(val=='IN_REVIEW') ? 'badge-neon badge-neon-warning-outline ms-2' : '' ,
                                (val=='NOT_YET_STARTED') ? 'badge-neon badge-neon-grey-outline ms-2' : '' ,
                                (val=='DONE_LATE') ? 'badge-neon badge-neon-error-outline ms-2' : '' ,
                                (val=='COMPLETED') ? 'badge-neon badge-neon-success-outline ms-2' : '' ,
                                (val=='REVERTED') ? 'badge-neon badge-neon-warning-outline ms-2' : '' ,
                                ]" :label="(val==='REVERTED' ? 'RE-ASSIGNED': val.replaceAll('_',' ') )"/>
                            </td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
</template>

<script>
import Badge from "../components/BadgeComponent.vue"
import { createNamespacedHelpers } from 'vuex';
const { mapActions: workSheetMapActions, mapGetters: workSheetMapGetters } = createNamespacedHelpers('WorkSheet');
export default {
    name: 'PerformanceDashboard',
    data() {
        return {

             series1: [{
            name: 'Net Profit',
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
          }, {
            name: 'Revenue',
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
          }, {
            name: 'Free Cash Flow',
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
          }],
          chartOptions1: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              title: {
                text: 'Score'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return " " + val + " "
                }
              }
            }
          },

            series: [],
            chartOptions: {
                chart: {
                    width: 380,
                    type: 'pie',
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                        console.log(dataPointIndex);
                        return w.config.series[seriesIndex];
                    },
                },
                labels: [],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: 'bottom',
                            },
                        },
                    },
                ],
            },
        };
    },
    methods: {
        ...workSheetMapActions({
            getAllScore: 'GET_ALL_SCORE',
            getProgress: 'GET_PROGRESS_BY_TRAINING_ID',
            getTrainingScore: 'GET_TRAINING_SCORE',
            getTrainingStatus: 'GET_TRAINING_STATUS'
        }),
    },
    components:{
        Badge
    },
    computed: {
        ...workSheetMapGetters({
            allscore: 'getAllScore',
            progress: 'getProgress',
            trainingScore: 'getTrainingScore',
            trainingStatus: 'getTrainingStatus'
        }),
    },
    created() {
        this.getAllScore(this.$route.query.trainingId);
        this.getProgress(this.$route.query.trainingId);
        // let payload={trainingId:this.$route.query.trainingId}
        this.getTrainingScore({trainingId:this.$route.query.trainingId})
        this.getTrainingStatus({id:this.$route.query.trainingId})
        // this.chartOptions1.xaxis.categories=this.trainingScore.name
        
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';
.info {
    background-color: #fff9e9;
    border-radius: 5px;
}
.fa-circle-exclamation {
    color: #fec12f;
}
.fade-text {
    color: $dark-200;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
</style>
